/** @deprecated Use `createStorage` from `../createStorage` instead. */
export class ArrayStorage<T = string> {
    constructor(
        readonly key: string,
        readonly storageProvider: Storage = localStorage,
    ) {}

    retrieve(): T[] {
        const serialized = this.storageProvider.getItem(this.key);
        if (serialized === null) {
            return [];
        }

        let deserialized: unknown;
        try {
            deserialized = JSON.parse(serialized);
        } catch (error) {
            return [];
        }

        if (!Array.isArray(deserialized)) {
            return [];
        }

        return deserialized;
    }

    persist(array: readonly T[]): void {
        if (!Array.isArray(array)) {
            return;
        }

        let serialized: string;
        try {
            serialized = JSON.stringify(array);
        } catch (error) {
            return;
        }

        this.storageProvider.setItem(this.key, serialized);
    }
}
